<template>
  <div>
    <PageMain
      :loading="loading"
      :tableData="tableData"
      @reload="$refs.header.query()"
      ref="tableMain"
      @radio-change="(e) => $emit('radio-change', e)"
    >
      <page-header ref="header" slot="header" @query="getData" />
    </PageMain>
  </div>
</template>
<script>
import PageMain from './table.vue'
import PageHeader from './header'
import EditLoading from '@/mixins/edit-loading'
import { request } from '@/api/service'
export default {
  mixins: [EditLoading],
  components: { PageMain, PageHeader },
  props: { scmCode: { type: String, default: () => '' } },
  data() {
    return { loading: false, tableData: [] }
  },
  methods: {
    async getData(form = {}) {
      if (!this.scmCode) return
      this.loading = true
      const res = await request({
        url: '/digitalCenter/scmInfo/bank/list',
        method: 'post',
        data: { scmCode: this.scmCode, ...form },
      }).catch(() => null)
      this.loading = false
      this.tableData = (res || {}).body.data
    },
  },
}
</script>
